<div class="gpd-full-page project-config-page" *ngIf="!configService.isProjectConfigStatusLoading">
  <div class="steps-container">
    <h3 i18n="@@completeBoth">Please complete both required steps below to view a project plan</h3>

    <div class="step-item">
      <div class="step-check" *ngIf="hasProjectConfiguration">
        <app-svg-icon
          icon="tick"
          [size]="24"
          [strokeWidth]="2.0"
          color="var(--color-green-500)"
          class="gpd-button-icon"
        ></app-svg-icon>
      </div>
      <div class="step-content">
        <div class="step-label" i18n="@@step1Label">Step 1: Define Phases, Milestones and Task Packages</div>
        <div class="step-description" i18n="@@step1Desc">
          Define the phases, milestones and task packages of your project to establish a clear structure and timeline.
        </div>
      </div>
      <div class="step-action">
        <ng-container *ngIf="!hasProjectConfiguration">
          <app-gpd-button
            text="Go To Step 1"
            i18n-text="@@toStepOne"
            icon="arrow-right"
            (click)="goToProjectConfiguration()"
            type="secondary"
          ></app-gpd-button>
        </ng-container>
        <ng-template #projectConfigDone>
          <span class="checkmark">✔️</span>
        </ng-template>
      </div>
    </div>

    <div class="step-item">
      <div class="step-check" *ngIf="hasAreaType">
        <app-svg-icon
          icon="tick"
          [size]="24"
          [strokeWidth]="2.0"
          color="var(--color-green-500)"
          class="gpd-button-icon"
        ></app-svg-icon>
      </div>
      <div class="step-content">
        <div class="step-label" i18n="@@step2Label">Step 2: Define Area Types</div>
        <div class="step-description" i18n="@@step2Desc">
          Define the types of area used in your project. For each type of area, a project schedule will be created and
          can be modified.
        </div>
      </div>
      <div class="step-action">
        <ng-container *ngIf="!hasAreaType">
          <app-gpd-button
            text="Go to Step 2"
            i18n-text="@@toStepTwo"
            (click)="goToAreaType()"
            icon="arrow-right"
            type="secondary"
          ></app-gpd-button>
        </ng-container>
        <ng-template #areaTypeDone>
          <span class="checkmark">✔️</span>
        </ng-template>
      </div>
    </div>
  </div>
</div>

